/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CodeEditorOutputViewerTitleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('CODE_EDITOR_OUTPUT_VIEWER_TITLE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class CodeEditorOutputViewerTitleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodeEditorOutputViewerTitleSettingParser.decode(input).map(res => new CodeEditorOutputViewerTitleSetting(res));
    }
    static unsafeDecode(input) {
        return CodeEditorOutputViewerTitleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeEditorOutputViewerTitleSettingParser.encode(data);
    }
    static schema() {
        return CodeEditorOutputViewerTitleSettingParser.schema();
    }
}
